// extracted by mini-css-extract-plugin
export default {"menuControls":"c-a_ey"};